var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoltFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 25,
    viewBox: "0 0 18 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_54_1894",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 18,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_54_1894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.02892 12.8771L7 4.5H14L11.0807 9.85211C11.0443 9.91875 11.0925 10 11.1685 10H14.8131C14.893 10 14.9407 10.089 14.8964 10.1555L8.47871 19.7819C8.36115 19.9583 8.08605 19.8546 8.11406 19.6446L9 13H5.12626C5.06178 13 5.01415 12.9399 5.02892 12.8771Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoltFilled);
export default __webpack_public_path__ + "static/media/bolt_filled.eede0902c4d4bb915db6345dd8343b2a.svg";
export { ForwardRef as ReactComponent };